
































import { computed, defineComponent } from '@vue/composition-api';
import { useGroups } from '@/store/modules/group';
import { useAllResources } from '@/store/modules/resources';
import AdminFieldListItemContent from './AdminFieldListItemContent.vue';
import FieldReassign from './FieldReassign.vue';

export default defineComponent({
	components: {
		AdminFieldListItemContent,
		FieldReassign,
	},
	setup(_, { root }) {
		const {
			isLoading: resourcesAreLoading,
			isLoaded: resourcesAreLoaded,
			hasError: resourcesHaveError,
			fields,
		} = useAllResources(root.$store);
		const { isLoading: groupsAreLoading, isLoaded: groupsAreLoaded, hasError: groupsHaveError, groups } = useGroups(
			root.$store
		);

		const isLoaded = computed(() => resourcesAreLoaded.value && groupsAreLoaded.value);

		const isLoading = computed(() => [resourcesAreLoading.value, groupsAreLoading.value].some(Boolean));

		const hasError = computed(() => [resourcesHaveError.value, groupsHaveError.value].some(Boolean));

		return {
			isLoaded,
			isLoading,
			hasError,
			fields,
			groups,
		};
	},
});
